import React from "react";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Grid from "@mui/material/Grid";
const UserHeader = (props) => {
  return (
    <>
      <CardMedia
        className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
        style={{
          minHeight: "600px",
          backgroundImage:
            "url(" +
            require("../../assets/img/theme/cisbackgroud-dark.jpg").default +
            ")",
          backgroundSize: "cover",
          backgroundPosition: "center top",
        }}
      >
        <span className="mask opacity-6" />
        <Container className="d-flex align-items-center" fluid>
          <Grid container direction="row">
            <Grid item lg="18" md="10">
              <a href="#pablo" onClick={(e) => e.preventDefault()}>
                <img
                  alt="..."
                  style={{ height: "250px", width: "200px" }}
                  src={
                    require("../../assets/img/theme/squarewhitewithsite.png")
                      .default
                  }
                />
              </a>
            </Grid>
          </Grid>
        </Container>
      </CardMedia>
    </>
  );
};

export default UserHeader;